import { render } from "./UniqueWordNumber.vue?vue&type=template&id=073eeaf6&scoped=true&ts=true"
import script from "./UniqueWordNumber.vue?vue&type=script&lang=ts"
export * from "./UniqueWordNumber.vue?vue&type=script&lang=ts"

import "./UniqueWordNumber.vue?vue&type=style&index=0&id=073eeaf6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073eeaf6"]])

export default __exports__